export default __webpack_public_path__ + "static/media/Engrace_4_Floor_Plans_SF.f94adf60.pdf";